import { assign, createMachine } from 'xstate';
import type { DoneInvokeEvent, EventObject, PropertyMapper } from 'xstate';

import { getDraftOrder } from '~/subscription-management/draft-order';

import type { DraftOrderData } from '~/subscription-management/draft-order';
import type { DraftOrderFetcherContext } from './draft-order-fetcher.machine.types';

import { getUpdatedProductAllowances } from '../utils/events';

export const draftOrderFetcherMachine = createMachine(
  {
    // eslint-disable-next-line @typescript-eslint/consistent-type-imports
    tsTypes: {} as import('./draft-order-fetcher.machine.typegen').Typegen0,
    id: 'draft-order-fetcher',
    initial: 'getDraftOrder',
    schema: {
      context: {} as DraftOrderFetcherContext,
      services: {} as {
        getDraftOrder: { data: DraftOrderData };
      },
    },
    states: {
      getDraftOrder: {
        invoke: {
          src: 'getDraftOrder',
          onDone: [
            {
              target: 'done',
              actions: assign<DraftOrderFetcherContext, DoneInvokeEvent<DraftOrderData>>(
                (context, event) => ({
                  ...getUpdatedProductAllowances({
                    allAllowances: context.allEffectiveAllowances,
                    previouslyAddedAllowances: context.allowancesToAdd,
                    toAddAllowances: event.data.products ?? [],
                    hasActiveSubscription: context.hasActiveSubscription,
                  }),
                  billingPeriod: event.data.billingPeriod ?? context.billingPeriod,
                  loadedFromDraftOrder: event.data.products !== null,
                }),
              ),
            },
          ],
          onError: [{ target: 'done' }],
        },
      },
      done: {
        type: 'final',
        data: {
          allowancesToAdd: (context) => context.allowancesToAdd,
          allowancesToRemove: (context) => context.allowancesToRemove,
          loadedFromDraftOrder: (context) => context.loadedFromDraftOrder,
          billingPeriod: (context) => context.billingPeriod,
        } as PropertyMapper<DraftOrderFetcherContext, EventObject, DraftOrderFetcherContext>,
      },
    },
  },
  {
    services: {
      getDraftOrder: () => getDraftOrder(),
    },
  },
);
